// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fd3e7923","239":"e09d50d8","732":"a6525a2a"}[chunkId] + ".chunk.js";
};